export default __webpack_public_path__ + "static/media/cnp20_5.8ce33c32.png";